import { forwardRef } from 'react';

export const QuestionMarkIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <circle cx="10" cy="10" r="10" fill="#004B54" />
        <path
          d="M10.7159 11.9288H9.01776C9.0222 11.5255 9.05327 11.1783 9.11099 10.8871C9.17314 10.5914 9.27747 10.3248 9.42397 10.0874C9.57492 9.84991 9.77469 9.6147 10.0233 9.38172C10.232 9.19355 10.414 9.01434 10.5694 8.84409C10.7248 8.67384 10.8468 8.4991 10.9356 8.31989C11.0244 8.1362 11.0688 7.93235 11.0688 7.70833C11.0688 7.44848 11.0289 7.23342 10.9489 7.06317C10.8735 6.88844 10.758 6.75627 10.6027 6.66667C10.4517 6.57706 10.2608 6.53226 10.03 6.53226C9.83907 6.53226 9.66149 6.57482 9.49723 6.65995C9.33296 6.74059 9.19756 6.86604 9.09101 7.03629C8.9889 7.20654 8.93563 7.43056 8.93119 7.70833H7C7.01332 7.09453 7.15316 6.58826 7.41953 6.18952C7.69034 5.78629 8.05216 5.48835 8.50499 5.2957C8.95782 5.09857 9.46615 5 10.03 5C10.6515 5 11.1842 5.10305 11.6282 5.30914C12.0721 5.51075 12.4118 5.80869 12.6471 6.20296C12.8824 6.59274 13 7.06765 13 7.62769C13 8.01747 12.9245 8.3647 12.7736 8.66935C12.6226 8.96953 12.4251 9.24955 12.1809 9.50941C11.9367 9.76927 11.6681 10.0381 11.3751 10.3159C11.1221 10.5444 10.9489 10.7841 10.8557 11.0349C10.7669 11.2858 10.7203 11.5838 10.7159 11.9288ZM8.81798 14.0054C8.81798 13.7186 8.91565 13.4812 9.11099 13.293C9.30633 13.1004 9.56826 13.004 9.89678 13.004C10.2209 13.004 10.4806 13.1004 10.6759 13.293C10.8757 13.4812 10.9756 13.7186 10.9756 14.0054C10.9756 14.2832 10.8757 14.5184 10.6759 14.711C10.4806 14.9037 10.2209 15 9.89678 15C9.56826 15 9.30633 14.9037 9.11099 14.711C8.91565 14.5184 8.81798 14.2832 8.81798 14.0054Z"
          fill="white"
        />
      </svg>
    );
  },
);
